import {getZoneInfo} from '@peachy/zone-config-pure'

export function useServicePatch() {
    const zoneInfo = getZoneInfo()
    return zoneInfo.servicePatchUrl
}

